import React, { FC, useEffect } from "react"
import L10n from "lib/carrot-l10n"
import { FlexRowCenter, Spacer } from "components/views/atoms/Atoms"
import { Body } from "components/views/atoms/Bodies"
import { IlloBlocks } from "../../../atoms/Illustrations"
import { useSelector } from "react-redux"
import { getShouldFillOutBankInfo } from "../../../../../derivedSelectors"
import { Steps } from "../Workflow/Steps"
import WeWillTakeItFromHere from "../WeWillTakeItFromHere"
import { BankInfoOptionButtons } from "./BankInfoOptionButtons"
import { useProgressTracker } from "../../ProgressTracker"
import { useConnectInsurance } from "../../../../context/enrollment/ConnectInsuranceContext"
import { useStateMachine } from "../../../../context/stateMachine/StateMachineContext"
import { useBenefitEnrollmentFlow } from "../BenefitEnrollmentFlowModal"
import { H2 } from "@carrotfertility/carotene"

const l = new L10n({ locale: "en-US" }).getBoundLocalize()

const ViewName = Steps.PROCESS_CONNECT_INSURANCE_SUCCESS
const ProcessConnectInsuranceSuccessView: FC = () => {
  const { setProgress } = useProgressTracker()
  const { hideOptionalInsuranceInfoPromo } = useConnectInsurance()
  const { onExit } = useBenefitEnrollmentFlow()
  const needsBankInfo = useSelector(getShouldFillOutBankInfo)
  useStateMachine(ViewName, null)

  useEffect(() => {
    hideOptionalInsuranceInfoPromo()
    setProgress(2, "CONNECT YOUR INSURANCE")
  }, [])

  return (
    <div>
      <Spacer height={3} />
      <FlexRowCenter>
        <IlloBlocks />
      </FlexRowCenter>
      <Spacer height={1} />
      <H2 variant="dark">{l`Connection was successful.`}</H2>
      <Spacer height={1} />
      <WeWillTakeItFromHere />
      {needsBankInfo && (
        <>
          <Spacer height={1} />
          <Body color="black-80">{l`Next, update your bank info so we can direct reimbursement funds to the right account.`}</Body>
        </>
      )}

      <Spacer height={2} />
      <BankInfoOptionButtons {...{ needsBankInfo, onExit }} />
    </div>
  )
}

export { ProcessConnectInsuranceSuccessView }
